import { tv } from 'tailwind-variants'

import type {
  LayoutType,
  RadioCardVariant,
} from '@ui-kit/components/formComponents/RadioCardSet/types'

const radioCardSet = tv({
  slots: {
    container: 'grow gap-y-1 web:flex-1',
    list: 'flex flex-col gap-y-5 py-0',
  },
  variants: {
    layout: {
      wide: {
        list: 'grow gap-x-0',
      },
      compact: {
        list: [
          'ios:flex-row ios:gap-x-2.5 ios:gap-y-0',
          'android:flex-row android:gap-x-2.5 android:gap-y-0',
          'md:flex-row md:gap-x-2.5 md:gap-y-0',
        ],
      },
    },
    variant: {
      card: {},
      chip: {
        list: 'gap-2.5 web:flex-row',
      },
    },
    hasTopTags: {
      true: {},
    },
    hasBottomTags: {
      true: {},
    },
  },
})

interface TaggedOption {
  topTag?: unknown
  bottomTag?: unknown
}

export const getRadioCardSetStyles = (
  options: readonly TaggedOption[],
  layout: LayoutType,
  variant: RadioCardVariant | undefined
) => {
  const hasTopTags = options.some((option) => option.topTag !== undefined)
  const hasBottomTags = options.some((option) => option.bottomTag !== undefined)
  return {
    hasTopTags,
    hasBottomTags,
    ...radioCardSet({ hasTopTags, hasBottomTags, layout, variant }),
  }
}
